var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',_vm._l((_vm.list),function(l){return _c('li',{key:l.title},[(_vm.data.type.endsWith('link'))?_c('router-link',{attrs:{"to":l.link}},[_vm._v(" "+_vm._s(_vm.data.translate ? _vm.$t(l.title) : l.title)+" ")]):[_vm._v(" "+_vm._s(_vm.data.translate ? _vm.$t(l.title) : l.title)+" ")]],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }